<div class="header flex-row space-between items-center">
    <div class="label-text">{{ headingTitle }} <span class="desc">{{ headingTitleSubtext }}</span></div>
    <mat-icon *ngIf="!editMode && !isUpdatingAttachment && canModify " class="addAttachment-btn" (click)="addNewDocs()">add</mat-icon>
</div>
<div *ngIf="editMode" class="label-text-editing">Uploads not allows when editing an offer.</div>
<div>
    <div *ngIf="!editMode && canModify">
        <div *ngFor="let result of validationResults" [ngClass]="{ 'upload-error': !result.isValid, 'upload-success': result.isValid }">
            <mat-icon *ngIf="!result.isValid" class="material-icons" color="warn">error</mat-icon>
            <mat-icon *ngIf="result.isValid" class="material-icons">done</mat-icon>
            <div class="upload-error-text">
                <div class="file-upload__message">{{result.message}}</div>
            </div>
        </div>
        <form method="POST" enctype="multipart/form-data" #fileForm
            (dragover)="updateDragState($event)" (dragleave)="updateDragState($event)" (drop)="getDroppedFiles($event)">
            <input 
                #fileInput 
                class="uploadInputType" 
                type="file" 
                accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,message/rfc822,application/vnd.ms-outlook,text/plain,image/jpeg,image/jpg,image/tiff,image/gif,image/bmp,image/png,image/bpg,image/svg" 
                id="file-input" 
                (change)="addSelectedFiles()" 
                multiple>
            <div [ngClass]="{ 'drop-target': true, 'drag-over': isDragging, 'empty': !document.files.length }">
                <ng-container *ngIf="!document.files.length">
                    <div class="drag-drop-display">
                        <mat-icon class="material-icons" color="primary">insert_drive_file</mat-icon>
                        <label for="file-input">Drag &amp; Drop</label>
                    </div>
                </ng-container>
                <ng-container *ngIf="document.files.length">
                    <div class="file-item file-item__header">
                        <div>File Name</div><div>&nbsp;</div>
                    </div>
                    <div *ngFor="let file of document.files" class="file-item">
                        <div>{{file.name}}</div>
                        <div class="button-container">
                            <button mat-icon-button (click)="removeFile(file)" *ngIf="!uploadInProgress" data-qa-id="shared_remove_attachment_btn">
                                <mat-icon class="material-icons" color="primary">delete</mat-icon>
                            </button>
                            <img *ngIf="uploadInProgress" class="spinner" src="./assets/images/spinner1.gif" alt="spinner" />
                        </div>
                    </div>
                </ng-container>
            </div>
        </form>
    </div>

    <div *ngIf="!editMode && canModify" class="control-buttons flex-row">
        <button mat-raised-button color="primary" [disabled]="!document.files.length" (click)="uploadFiles()">{{ isUpdatingAttachment ? 'Update' : 'Upload'}} Docs</button>
    </div>
    
    <table class="attachments-table table table-bordered" aria-label="Attachments Table">
        <thead class="thead-light">
            <tr>
                <th scope="col">Document Name</th>                
                <th scope="col">Actions</th>
                <th scope="col">Upload Date</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngIf="!attachmentData?.length">
                <td colspan="3" class="no-attachment-msg">No attachments have been uploaded.</td>
            </tr>
            <tr *ngFor="let file of attachmentData">
                <td>
                    <span class="nova__link" (click)="getAttachment(file)">{{ file.fileName }}</span>
                </td>                
                <td>
                    <div class="attachment-actions">
                        <button mat-icon-button color="primary" (click)="replaceAttachment(file.id)" matTooltip="Edit" class="cell-pointer">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="primary" (click)="getAttachment(file)" matTooltip="Download" class="cell-pointer">
                            <mat-icon>file_download</mat-icon>
                        </button>
                        <button mat-icon-button color="primary" (click)="deleteAttachment(file)" matTooltip="Delete" class="cell-pointer">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </div>
                </td>
                <td>{{ file.uploadDate | date: 'MM/dd/yyy h:mm a' }}</td>
            </tr>
        </tbody>
    </table>
</div>
